module.exports = __webpack_public_path__ + "img/golf.8a078592.png";